// extracted by mini-css-extract-plugin
export default {"data_container":"CoinData_data_container__R0qud"};